















import { Component, Vue } from 'vue-property-decorator';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';

@Component({
  components: {
    DxPopup,
    DxScrollView
  },
})
export default class InvoiceCannotBeDeletedDialog extends Vue {
  showPopup: boolean = false;

  show() {
    this.showPopup = true;
  }

  hide() {
    this.showPopup = false;
  }

  assignId(e: any) {
    e.component.content().setAttribute('id', 'invoiceCannotBeDeletedDialog');
  }
}
